var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2985 9.64582C18.4942 9.84073 18.4947 10.1573 18.2998 10.3529L12.8348 15.8374C12.6199 16.0531 12.2706 16.0531 12.0556 15.8374L6.59064 10.3529C6.39573 10.1573 6.39629 9.84073 6.5919 9.64582C6.78751 9.4509 7.10409 9.45147 7.29901 9.64708L12.4452 14.8117L17.5914 9.64708C17.7864 9.45147 18.1029 9.4509 18.2985 9.64582Z",
    fill: "#668CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowDown);
export default __webpack_public_path__ + "static/media/select-arrow-down.a6b8e016cdc8b88e942ca042bb4bb77c.svg";
export { ForwardRef as ReactComponent };